import { createContext } from "react";

import type { NewPasswordChallenge } from "@/services/auth";

export interface UserData {
  avatar: string;
  name: string;
  email: string;
  id: string;
  groups: string[];
}

export interface IAuthContext {
  profile: UserData;
  login?: (credentials: {
    username: string;
    password: string;
  }) => Promise<NewPasswordChallenge | void>;
  logout?: VoidFunction;
  fetchUserData?: VoidFunction;
  userHasGroup: (group: string[]) => boolean;
}

export const initialAuthContext: IAuthContext = {
  profile: { avatar: "", name: "", email: "", id: "", groups: [] },
  login: undefined,
  logout: undefined,
  userHasGroup: () => false,
};

const AuthContext = createContext<IAuthContext>(initialAuthContext);

export default AuthContext;
